 /**
 * 用户权限和登录状态相关工具函数
 */

const USER_ROLE_KEY = 'userRole';
const TOKEN_KEY = 'token';
const USER_INFO_KEY = 'userInfo';

/**
 * 获取用户角色
 * @returns {String} 用户角色('teacher'或'student')
 */
export function getUserRole() {
  return localStorage.getItem(USER_ROLE_KEY);
}

/**
 * 设置用户角色
 * @param {String} role 用户角色
 */
export function setUserRole(role) {
  return localStorage.setItem(USER_ROLE_KEY, role);
}

/**
 * 移除用户角色
 */
export function removeUserRole() {
  return localStorage.removeItem(USER_ROLE_KEY);
}

/**
 * 获取 token
 * @returns {String} token
 */
export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

/**
 * 设置 token
 * @param {String} token
 */
export function setToken(token) {
  return localStorage.setItem(TOKEN_KEY, token);
}

/**
 * 移除 token
 */
export function removeToken() {
  return localStorage.removeItem(TOKEN_KEY);
}

/**
 * 获取用户信息
 * @returns {Object} 用户信息对象
 */
export function getUserInfo() {
  const userInfoStr = localStorage.getItem(USER_INFO_KEY);
  return userInfoStr ? JSON.parse(userInfoStr) : null;
}

/**
 * 设置用户信息
 * @param {Object} userInfo 用户信息对象
 */
export function setUserInfo(userInfo) {
  return localStorage.setItem(USER_INFO_KEY, JSON.stringify(userInfo));
}

/**
 * 移除用户信息
 */
export function removeUserInfo() {
  return localStorage.removeItem(USER_INFO_KEY);
}

/**
 * 登出清理
 */
export function logout() {
  removeToken();
  removeUserRole();
  removeUserInfo();
}